import React from 'react';

import Layout, { Content } from 'antd/lib/layout/layout';
import { Card, Typography, Space, Divider } from 'antd';
import { Navigate } from 'react-router-dom';
import paths from 'assets/routes/paths';
import { UserOutlined, LockOutlined, SafetyCertificateOutlined } from '@ant-design/icons';
import LoginForm from '../components/admin/LoginForm';
import { getAccessTokenApi } from '../api/auth';
import Logo from 'components/Logo/Logo';
import { useTenantBranding } from 'providers/Tenant/TenantBrandingProvider';

function SignIn() {
  const { branding } = useTenantBranding();
  const tenantName = branding?.organization || 'Stiltech';

  if (getAccessTokenApi()) {
    return <Navigate to={paths.root} />;
  }

  return (
    <Layout className="sign-in min-h-screen">
      <div className="sign-in-background">
        <Card variant="borderless" className="sign-in-card shadow-2xl">
          <Content className="sign-in-content">
            <div className="image-side">
              <div className="image-overlay">
                <div className="welcome-content">
                  <Space direction="vertical" size="large" className="text-center">
                    <SafetyCertificateOutlined className="text-6xl text-white opacity-80" />
                    <div>
                      <Typography.Title level={2} className="text-white mb-2">
                        Bienvenido a {tenantName}
                      </Typography.Title>
                      <Typography.Text className="text-white text-lg opacity-90">
                        Sistema de gestión integral para ascensores
                      </Typography.Text>
                    </div>
                    <Divider className="border-white opacity-30" />
                    <Space direction="vertical" size="small">
                      <div className="flex items-center justify-center space-x-2 text-white">
                        <UserOutlined className="text-lg" />
                        <Typography.Text className="text-white">
                          Acceso seguro y confiable
                        </Typography.Text>
                      </div>
                      <div className="flex items-center justify-center space-x-2 text-white">
                        <LockOutlined className="text-lg" />
                        <Typography.Text className="text-white">Datos protegidos</Typography.Text>
                      </div>
                    </Space>
                  </Space>
                </div>
              </div>
            </div>
            <div className="form-container">
              <div className="form-header">
                <Logo />
                <div className="text-center mt-6">
                  <Typography.Title level={3} className="text-gray-800 mb-2">
                    Iniciar Sesión
                  </Typography.Title>
                  <Typography.Text type="secondary" className="text-base">
                    Ingresa tus credenciales para acceder al sistema
                  </Typography.Text>
                </div>
              </div>
              <LoginForm />
            </div>
          </Content>
        </Card>
      </div>
    </Layout>
  );
}

export default SignIn;
